import { render, staticRenderFns } from "./input-number.vue?vue&type=template&id=68046b28&scoped=true&"
import script from "./input-number.vue?vue&type=script&lang=js&"
export * from "./input-number.vue?vue&type=script&lang=js&"
import style0 from "./input-number.vue?vue&type=style&index=0&id=68046b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68046b28",
  null
  
)

export default component.exports